var Request = require("../helper/request");

function Location(app, userId){
	var self = this;
	self.request = new Request(app);
	self.userId = userId;

	self.routes = {
		show: {
			url: '/iam/user/'+self.userId+'/location',
			method: 'GET'
		},
		create: {
			url: '/iam/user/'+self.userId+'/location',
			method: 'POST'
		},
		delete: {
			url: "/iam/user/"+self.userId+"/location",
			method: 'DELETE'
		}
	};
}

Location.prototype.show = function(){
	var self = this;
	return self.request.get(self.routes.show.url);
}

Location.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		location: data
	});
}

Location.prototype.delete = function(){
	var self = this;
	return self.request.delete(self.routes.delete.url);
}

module.exports = Location;